const BetOfferMultiPosition = {
  title: 'Example JSON',
  expectedOutput: '(1st) Canny Betty, (2nd) Farloe Moby, (3rd) Nitro June',
  initialDisplayedCode: `{
      "outcomeId": "",
      "multiPositionBetOfferLabelOneLine": true,
      "selections": {
        "1018896521_1028284759": "FIRST",
        "1018896521_1028278461": "SECOND",
        "1018896521_1028295999": "THIRD"
      },`,
  moreCode: `"betOffer": {
      "id": 2340032470,
      "criterion": {
        "label": "Multi position"
      },
      "betOfferType": {
        "id": 19,
        "name": "(1-3)"
      },
      "placeLimit": 3
    },
    "event": {
      "id": 1018896521,
      "participants": [{
          "participantId": 1028284759,
          "name": "Canny Betty",
          "selection": "FIRST"
      },{
          "participantId": 1028278461,
          "name": "Farloe Moby",
          "selection": "SECOND"
      },{
          "participantId": 1028295999,
          "name": "Nitro June",
          "selection": "THIRD"
      }]
    }
  }`,
};

export default BetOfferMultiPosition;
